module.exports = __webpack_public_path__ + "img/icn_meeting.1c06057e.svg";